import CompanyCourseCommission, {
  CompanyCourseCommissionFormSend,
} from "@/interfaces/CompanyCourseCommission";
import api from "@/services/api";

export const companyCourseCommissionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyCourseCommissions: build.query<
      CompanyCourseCommission[],
      [string, string]
    >({
      query: ([companyId, courseId]) =>
        `/companies/${companyId}/courses/${courseId}/commissions`,
      providesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCourseCommissions", companyId, courseId },
      ],
    }),
    updateCompanyCourseCommission: build.mutation<
      CompanyCourseCommission,
      [string, string, string, CompanyCourseCommissionFormSend]
    >({
      query: ([companyId, courseId, id, body]) => ({
        url: `/companies/${companyId}/courses/${courseId}/commissions/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCourseCommissions", companyId, courseId },
        { type: "CommissionStats", id: "ME" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCompanyCourseCommissionsQuery,
  useUpdateCompanyCourseCommissionMutation,
} = companyCourseCommissionsApi;
